export default __webpack_public_path__ + "d4980927be095bfe17cb7bcbafabd396.png";